import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IUserList {
    active_exchanges?: any
    change_count?: number
    copy_allowed?: boolean
    created_at?: number
    email?: string
    email_confirmed?: boolean
    followers?: number
    following?: number
    id: string
    my_referral_code?: string
    name?: string
    network?: string
    phone?: string
    phone_confirmed?: boolean
    privacy_level?: number
    referral_user_count?: number
    status?: string
    thumbnail?: string
    type?: number
    usd_balance?: number
    used_referral_code?: {id: string; name: string; thumbnail: string}
    is_pro?: boolean
    is_filtered?: boolean
    pro_until?: string
}

export const getUserList = async (
    size: number = 10,
    current: number = 1,
    name?: string,
): Promise<ApiRes<IUserList[]>> => {
    return await apiGet(API_URL, `admin/users?page_size=${size}&current_page=${current}&name=${name ? name : ''}`)
}
